import { RouteLocation } from "vue-router";
import { useUserStore } from './../store/userStore';


export default (async (to: RouteLocation, from: RouteLocation) => {
  const userStore = useUserStore();

  //Remove token from URL
  // let urlToken = new URLSearchParams(window.location.search).get("token");
  // if (urlToken) { return "/staff/overview" }
  
  if (!userStore.isStaffUser) {

    //console.log("StaffGuard> No staff user token found.");
    //return `/staff/login?returnUrl=${to.fullPath}`;
  }
  else { 
      //console.log("StaffGuard> User Token Present. Staff user is logged in."); 
  }
});
